module.exports = __webpack_public_path__ + "img/user.3f883b49.png";